import config from '../../../../config';

import {deepCopy} from '../../../utils/arrays';

const displayDocumentsTab = config.featureFlags.relationshipDocuments?.clientDocuments;

const DOCUMENTS_TAB = {
  label: 'project.documents',
  text: 'project.documents',
  loading: false,
  path: '/client/:clientId/documents',
  counter: 0
};

const USERS_TAB = {
  label: 'organisation.users.title',
  text: 'organisation.users.title',
  loading: false,
  path: '/client/:clientId/users',
  counter: 0
};

const PROJECTS_TAB = {
  label: 'project.myProjects',
  text: 'project.myProjects',
  loading: false,
  path: '/client/:clientId/projects',
  counter: 0
};

const TAB_ITEMS = displayDocumentsTab ?
  [DOCUMENTS_TAB, USERS_TAB, PROJECTS_TAB] :
  [USERS_TAB, PROJECTS_TAB];

export const TAB_PATH = displayDocumentsTab ?
  ['/documents', '/users', '/projects'] :
  ['/users', '/projects'];

export const TAB_INDEXES = displayDocumentsTab ?
  {
    documents: 0,
    users: 1,
    interventions: 2
  } :
  {
    users: 0,
    interventions: 1
  };

export const getTabItems = (items = TAB_ITEMS) => deepCopy(items);
